import { useState } from "react"

import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import Stack from "@mui/material/Stack"
import FormControl from "@mui/material/FormControl"
import InputLabel from "@mui/material/InputLabel"
import MenuItem from "@mui/material/MenuItem"
import Select from "@mui/material/Select"
import Button from "@mui/material/Button"
import TextField from "@mui/material/TextField"
import Typography from "@mui/material/Typography"

function ModalAction({ open, handleClose, onAddAction, enableResponseComent }) {
    const [data, setData] = useState({
        actionType: "",
        delay: 0,
        content: "",
        buttonLabel: "",
        buttonUrl: "",
    })

    const handleChange = (key, value) => {
        setData({
            ...data,
            [key]: value,
        })
    }

    const onCloseClick = () => {
        setData({
            actionType: "",
            delay: 0,
            content: "",
        })

        handleClose()
    }

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
            <DialogTitle>Ação</DialogTitle>
            <DialogContent>
                <Stack spacing={2}>
                    <FormControl fullWidth>
                        <InputLabel>Tipo de Ação</InputLabel>
                        <Select
                            label="Tipo de Ação"
                            defaultValue="dm-message"
                            value={data.actionType}
                            onChange={(e) =>
                                handleChange("actionType", e.target.value)
                            }
                        >
                            <MenuItem value={"dm-message"}>
                                Enviar Mensagem na DM
                            </MenuItem>
                            {enableResponseComent && (
                                <MenuItem value={"response-comment"}>
                                    Resposta ao Comentário
                                </MenuItem>
                            )}
                        </Select>
                    </FormControl>

                    <TextField
                        type="number"
                        label="Delay (minutos)"
                        value={data.delay}
                        onChange={(e) => handleChange("delay", e.target.value)}
                        slotProps={{
                            htmlInput: {
                                min: 0,
                                max: 360,
                            },
                        }}
                    />
                    <TextField
                        multiline
                        label="Conteúdo"
                        placeholder="Conteúdo da mensagem (até 500 caracteres)"
                        value={data.content}
                        onChange={(e) =>
                            handleChange("content", e.target.value)
                        }
                        slotProps={{
                            htmlInput: {
                                maxLength: 500,
                                rows: 4,
                            },
                        }}
                    />

                    {data.actionType === "dm-message" && (
                        <>
                            <Typography variant="subtitle2">CTA</Typography>
                            <Stack direction="row" spacing={2}>
                                <TextField
                                    fullWidth
                                    label="Label do botão"
                                    placeholder="Clique aqui"
                                    value={data.buttonLabel}
                                    onChange={(e) =>
                                        handleChange(
                                            "buttonLabel",
                                            e.target.value,
                                        )
                                    }
                                />
                                <TextField
                                    fullWidth
                                    label="URL do botão"
                                    placeholder="https://"
                                    value={data.buttonUrl}
                                    onChange={(e) =>
                                        handleChange(
                                            "buttonUrl",
                                            e.target.value,
                                        )
                                    }
                                />
                            </Stack>
                        </>
                    )}
                </Stack>
            </DialogContent>

            <DialogActions>
                <Button onClick={onCloseClick}>Cancelar</Button>
                <Button
                    variant="contained"
                    onClick={() => {
                        onAddAction(data)
                        onCloseClick()
                    }}
                >
                    Salvar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ModalAction
